export default "<button class=\"btn btn-block  bggreen fwhite button roundedbtn\" (click)=\"loadIframe()\">LOAD IFRAME</button>"